module.exports = __webpack_public_path__ + "static/media/DGA-คู่มือการใช้โปรแกรมที่พัฒนาและปรับปรุง_ส่วนภูมิภาค.1a81cb61.pdf";